module.exports = __webpack_public_path__ + "media/images/element/07-69b9de1988ba347a98155f8edfe287d4.svg";